import { useCallback } from 'react';
import { useCartUI } from '@context/CartContext';
import type { Cart } from '../../types/cart';
import { HookError } from '../../errorHandlers';

export const removeItemFetcher = async (itemId: string): Promise<Cart> => {
  if (!itemId) {
    throw new HookError('ItemId must be provided to remove item from cart');
  }

  const removeItemResponse = await fetch('/api/cart', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ itemId }),
  });

  const { data } = await removeItemResponse.json();
  return data;
};

const useRemoveItem = (onRemoveItem?: ({ data }: { data: Cart }) => void) => {
  const { updateCart, validateCartItems } = useCartUI();
  return useCallback(
    async (itemId: string) => {
      const data = await removeItemFetcher(itemId);
      updateCart(data);
      validateCartItems(true);
      try {
        onRemoveItem?.({ data });
      } catch (error) {
        console.log(error);
      }
    },
    [onRemoveItem, updateCart, validateCartItems]
  );
};

export default useRemoveItem;
